import {
  Auth
} from '@lcai/console-auth';

import useModelState from './_use-model-state';

export default function useAccount(): Auth {
  return useModelState().account;
}